export default __webpack_public_path__ + "static/media/logo.e8d04257.png";